import React, { useEffect, useState } from 'react';
import DropDownField from '../../../helpers/DropDownField';
import Button from '../../../helpers/Button';
import TextInputField from '../../../helpers/TextInputField';
import { useDispatch } from 'react-redux';
import { ConfirmDialog } from 'primereact/confirmdialog';
import { raiseToast } from '../../../services/redux/reducers/toast/toast';
import { CheckboxField } from '../../../helpers';

const MappedProduct = (props) => {
    const { 
        productDetails, 
        index, 
        removeRequirement, 
        handleProductChange,
        brandsData, 
        industryData, 
        uomsData,
        handleAutoFillProductData,
        handleActiveTab,
        handleMoveToSectiontwo,
        companyERPCodeMaps,
        orderTypeId,
        formErrors,
        products,
        setProducts, 
        requirement,
        buyerReqId
    } = props

    const { 
        productId, 
        materialId, 
        companyERPCode, 
        productName, 
        variantName , 
        specification, 
        brandId, 
        categoryId, 
        quantity, 
        materialUOMId, 
        uomValue, 
        buyerRateContractId,
        companyERPCodeMapId
    } = productDetails

    const [categories, setCategories] = useState([])
    const [visinleConfirmQty, setVisinleConfirmQty] = useState(false)

    const dispatch = useDispatch()

    useEffect(() => {
        const unknownCategory = {
            categoryId: 22,
            categoryName: "Unknown",
            createdAt: "2023-08-11T10:02:08.609Z",
            createdBy: 1,
            industryName: "Procmart",
            statusId: 2,
            updatedAt: "2023-08-11T10:02:08.609Z",
            updatedBy: 1
        }
        setCategories([...industryData, unknownCategory])

    }, [industryData])

    const handleMappedProductDelete = (productId) => {
        const newProductsList = products.filter(eachProduct => eachProduct.productId !== productId)
        setProducts([...newProductsList])
    }

    const handleMappedProductChange = (e) => {
        handleProductChange(productId, e.target.name, e.target.value)
        /*
        if(e.target.name === "quantity") {
            if ((e.target.value).toString().length <= 6) handleProductChange(productId, e.target.name, e.target.value)
        }
        else{
            handleProductChange(productId, e.target.name, e.target.value)
        }
        */
    }

    const handleChangeForTextInputs = (e) => {
        const charRegex = /^[A-Z0-9 ]+$/i

        if (!charRegex.test(e.target.value) && e.target.value !== "") {
            return
        }

        handleProductChange(productId, e.target.name, e.target.value)
    }

    const handleMaterialIdPriority = (e) => {
        const updatedProducts = products.map(eachProduct => {
            if (eachProduct.productId === productId) {
                return { ...eachProduct, isHighPriority: e.checked }
            }
            return eachProduct
        })
        setProducts(updatedProducts)
    }

    const handleAcceptClick = () => {
        setVisinleConfirmQty(false)
    }

    const handleRejectClick = () => {
        const updatedProducts = products.map(eachProduct => {
            if(eachProduct.productId === productId){
                return {...eachProduct, quantity: null}
            }
            return eachProduct
        }) 
        setProducts(updatedProducts)
        setVisinleConfirmQty(false)
    }

    const handleQuantityCheck = (e) => {
        if(e.target.name === "uomValue"){
            if(parseFloat(quantity) > 0 && parseFloat(uomValue) > 1 && (parseFloat(e.target.value) % parseFloat(quantity) === 0)){
                setVisinleConfirmQty(true)
            }
        }

        if(e.target.name === "quantity"){
            if (e.target.value === ""){
                e.target.value = 0
            }
            if (buyerReqId && parseFloat(e.target.value) < parseFloat(productDetails.existedQuantity)) {
                dispatch(raiseToast({ severity: 'error', detail: "Quantity should be more than already existed qty.", life: 3000 }))
                e.target.value = productDetails.existedQuantity
            }
            if(parseFloat(uomValue) > 1 && (parseFloat(e.target.value) % parseFloat(uomValue) === 0)){
                setVisinleConfirmQty(true)
            }
        }
    }

    const handleQuantityCheckOnEnter = (e) => {
        if(e.key === "Enter"){
            handleQuantityCheck(e)
        }
    }

    const handleCompanyERPCodeMapping = async (e, companyERPCodeMaps, orderTypeId) => {
        if(!e.target.value){
            const productData = {
                companyERPCode: null,
                materialId: null,
                productName: null,
                variantName: null,
                specification: null,
                categoryId: null,
                brandId: null,
                uomValue: null,
                materialUOMId: null,
                quantity: null,
                isMappedProduct: true,
                buyerRateContractId: null,
                companyERPCodeMapId: null,
                isOverRiddedProduct: false,
                isMaterialMasterProduct: false
            }
            handleAutoFillProductData(productId, productData)
            return 
        }   

        let erpCodeMatch = null
        if (orderTypeId === 1){
            if(e.target.name === "companyERPCode"){
                erpCodeMatch = companyERPCodeMaps.find(eachErp => eachErp.companyERPCode === e.target.value)
            }
            else if(e.target.name === "materialId"){
                erpCodeMatch = companyERPCodeMaps.find(eachErp => eachErp.materialId === parseInt(e.target.value))
            }
        }


        
        if (erpCodeMatch && orderTypeId === 1){

            const productData = {
                productId: productId,
                companyERPCode: erpCodeMatch?.companyERPCode,
                materialId: erpCodeMatch?.materialId,
                productName: erpCodeMatch?.companyProdName,
                variantName: erpCodeMatch?.variantName,
                specification: erpCodeMatch?.companyProdSpec,
                categoryId: erpCodeMatch?.categoryId,
                brandId: erpCodeMatch?.brandId,
                uomValue: erpCodeMatch?.UOMValue,
                materialUOMId: erpCodeMatch?.materialUOMId,
                quantity: '',
                companyERPCodeMapId: erpCodeMatch?.companyERPCodeMapId,
                isMappedProduct: true,
                buyerRateContractId: null,
                isOverRiddedProduct: false
            }
            handleAutoFillProductData(productId, productData)
        }
        else{
            if(e.target.value && requirement.bussinessTypeId === 1){
                if (e.target.name === "materialId") {
                    if (e.target.value.toString()[0] === '7') {
                        return dispatch(raiseToast({ severity: 'error', detail: `Can't search VMI materials in regular requirement!` }))
                    }
                    handleMoveToSectiontwo(productId, companyERPCode, materialId)
                }

                if(e.target.name === "companyERPCode"){
                    handleMoveToSectiontwo(productId, companyERPCode, "")
                }
            }
            else{
                const productData = {
                    companyERPCode: '',
                    materialId: '',
                    productName: '',
                    variantName: '',
                    specification: '',
                    categoryId: null,
                    brandId: null,
                    uomValue: null,
                    materialUOMId: null,
                    quantity: '',
                    isMappedProduct: true,
                    buyerRateContractId: null,
                    companyERPCodeMapId: null,
                    isOverRiddedProduct: false,
                    isMaterialMasterProduct: false
                }
                if(requirement.bussinessTypeId === 2){
                    dispatch(raiseToast({ severity: 'error', detail: `Material not found!` }))
                }
                handleAutoFillProductData(productId, productData)
            }
        }
    }

    const handleCompanyERPCodeMappingOnEnter = (e) => {
        if(e.key === "Enter"){
            handleCompanyERPCodeMapping(e, companyERPCodeMaps, orderTypeId)
        }
    }

    const uomName = uomsData.find(eachUOM => eachUOM.materialUOMId === materialUOMId)?.UOM 
    const relatedCompanyERPCodeMap = companyERPCodeMaps.find(eachERPCodeMap => eachERPCodeMap.companyERPCodeMapId === companyERPCodeMapId)

    const allowPriorityToChange = materialId && materialId.toString().length > 6 && requirement.bussinessTypeId === 1 && [1, 2, 3].includes(requirement.orderTypeId)

    const isIncrementalReq = buyerReqId && productDetails.buyerReqItemId

    return(
        <>
            <ConfirmDialog visible={visinleConfirmQty} closable={false} message={`Are you sure you want to proceed with ${parseFloat(uomValue)} ${uomName} * ${parseFloat(quantity)} = ${parseFloat(uomValue) * parseFloat(quantity)}`} icon="pi pi-info-circle" reject={() => handleRejectClick()} accept={() => handleAcceptClick()}/>
            <tr className="custom-table-tr custom-tr product-items-table">
                <td className="custom-td">{index + 1}</td>
                <td className="custom-td"><TextInputField name="companyERPCode" value={companyERPCode} onChange={handleMappedProductChange} onKeyDown={(e) => handleCompanyERPCodeMappingOnEnter(e, companyERPCodeMaps, orderTypeId)} onBlur={(e) => handleCompanyERPCodeMapping(e, companyERPCodeMaps, orderTypeId)} {...((buyerRateContractId || isIncrementalReq) ? {disabled: true} : {})} /> </td>
                <td className="custom-td"><TextInputField name="materialId" value={materialId} placeholder={materialId} onKeyDown={(e) => handleCompanyERPCodeMappingOnEnter(e, companyERPCodeMaps, orderTypeId)} onChange={handleMappedProductChange} onBlur={(e) => handleCompanyERPCodeMapping(e, companyERPCodeMaps, orderTypeId)} keyfilter={"pnum"} {...((buyerRateContractId || isIncrementalReq) ? {disabled: true} : {})} /></td>
                <td className="custom-td"><DropDownField name="categoryId" value={categoryId} onChange={handleMappedProductChange} options={categories} optionLabel="categoryName" optionValue="categoryId" disabled /></td>
                <td className="custom-td"><DropDownField name="brandId" value={brandId} onChange={handleMappedProductChange} options={brandsData} optionLabel="brandName" optionValue="brandId" disabled /></td>
                <td className="custom-td"><TextInputField name="productName" value={productName} tooltip={relatedCompanyERPCodeMap?.productName} tooltipOptions={{ position: 'top', showOnDisabled: true }} disabled /></td>
                {/* <td className="custom-td"><TextInputField name="variantName" value={variantName} onChange={handleMappedProductChange} disabled tooltip={variantName} tooltipOptions={{ position: 'top', showOnDisabled: true }} /></td> */}
                <td className="custom-td"><TextInputField name="specification" value={specification} onChange={handleMappedProductChange} tooltip={relatedCompanyERPCodeMap?.productSpecification} tooltipOptions={{ position: 'top', showOnDisabled: true, }} disabled /></td>
                <td className="custom-td"><TextInputField name="uomValue" value={uomValue} onChange={handleMappedProductChange} keyfilter={"pnum"} disabled /></td>
                <td className="custom-td"><DropDownField name="materialUOMId" value={materialUOMId} onChange={handleMappedProductChange} options={uomsData} optionLabel="UOM" optionValue="materialUOMId" disabled /></td>
                <td className="custom-td"><TextInputField name="quantity" value={quantity} onChange={handleMappedProductChange} keyfilter={"pnum"} disabled={materialUOMId ? false : true} onBlur={handleQuantityCheck} onKeyDown={handleQuantityCheckOnEnter}/></td>
                <td><div className='flex justify-content-center'>{allowPriorityToChange && <CheckboxField checked={productDetails.isHighPriority} onChange={handleMaterialIdPriority} disabled={categoryId === 22} />}</div></td>
                <td className="custom-td"><Button className="decrement-btn-icon" icon="pi pi-times-circle" text onClick={() => {handleMappedProductDelete(productId)}} disabled={(buyerReqId && productDetails.buyerReqItemId) ? true : false}/></td>
            </tr>
        </>
    )
}

export default MappedProduct